import * as Sentry from '@sentry/browser';

// TODO: optimizar para mejorar performance
Sentry.init({
    dsn: 'https://76546d5493dd40b989ce7abc1f06eac0@o481151.ingest.sentry.io/6701748',
    debug: false,
    release: process.env.APP_VERSION,
    environment: process.env.APP_ENV,
    tracesSampleRate: 0.1,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.captureConsoleIntegration({
            levels: ['error'],
        }),
    ],
});
